import NotificationService from '../../lib/api/notification.service';

export async function fetchNotifications({ commit }) {
  const response = await NotificationService.get();

  if (response.status === 200) {
    commit('setNotifications', response.data);
  }
}
